<script setup>

const props = defineProps({
  price: Number || String,
  digits: {
    type: Number,
    default: 2
  }
})

const formattedPrice = computed(() => {
  if (props.price === null || props.price === undefined || isNaN(props.price)) {
    return '0' + '.' + '0'.repeat(props.digits);
  }
  
    return props.price.toLocaleString('sv-SE', {
    minimumFractionDigits: props.digits,
    maximumFractionDigits: props.digits,
  }).replace(/\s/g, '').replace(',', '.');
})
</script>

<template>
  {{ formattedPrice }}
</template>

<style scoped lang="scss">

</style>
